/**
 * Editorial section wrapper used by every body section in the dancer view.
 * Same vocabulary as the audition page: mono eyebrow label, optional count,
 * Sentient h2, optional secondary meta text.
 */
interface Props {
  eyebrow: string;
  title: string;
  count?: number;
  meta?: string;
  children: React.ReactNode;
}

export function DancerSection({
  eyebrow,
  title,
  count,
  meta,
  children,
}: Props) {
  return (
    <section className="border-foreground/15 border-b py-14 first:pt-0 last:border-b-0 lg:py-16">
      <header className="mb-8 flex flex-wrap items-baseline gap-x-5 gap-y-2 sm:mb-10">
        <p className="text-muted-foreground/80 font-mono text-[11px] tracking-[0.22em] uppercase">
          {eyebrow}
        </p>
        {typeof count === 'number' && (
          <p className="text-muted-foreground/60 font-mono text-[11px] tracking-[0.18em] uppercase tabular-nums">
            {count}
          </p>
        )}
        {meta && (
          <p className="text-muted-foreground hidden text-xs sm:inline">
            {meta}
          </p>
        )}
        <h2 className="font-heading text-foreground basis-full text-3xl leading-tight tracking-[-0.02em] sm:text-4xl lg:text-[2.75rem]">
          {title}
        </h2>
      </header>
      {children}
    </section>
  );
}
